/* ==== 00-core.js ==== */
/* Shop core: shared helpers for the shop.adelaxo.com clone sections (window.ShopTheme). Loaded before every other part. */
(function () {
  "use strict";
  var config = window.shopThemeConfig || {};

  function formatMoney(cents) {
    var format = config.moneyFormat || "${{amount}}";
    var amount = (Number(cents || 0) / 100).toFixed(2);
    var parts = amount.split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return format.replace(/\{\{\s*amount\s*\}\}/, parts.join("."));
  }

  /* Section Rendering API: returns { sectionId: html } for the given section file names. */
  function fetchSections(names, url) {
    var base = url || config.routes.root || "/";
    var join = base.indexOf("?") === -1 ? "?" : "&";
    /* No Accept: application/json here: with that header Shopify answers /cart with the cart JSON instead of the sections. */
    return fetch(base + join + "sections=" + names.join(","), { credentials: "same-origin" }).then(function (res) {
      if (!res.ok) throw new Error("sections " + res.status);
      return res.json();
    });
  }

  /* Swaps the inner HTML of the element matching selector with the same element of the rendered section. */
  function replaceSection(html, selector, target) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var next = doc.querySelector(selector);
    var current = target || document.querySelector(selector);
    if (next && current) current.innerHTML = next.innerHTML;
    return current;
  }

  var lockCount = 0;
  function lockScroll() {
    lockCount += 1;
    document.body.classList.add("shop-overflow-hidden");
  }
  function unlockScroll() {
    lockCount = Math.max(0, lockCount - 1);
    if (lockCount === 0) document.body.classList.remove("shop-overflow-hidden");
  }

  function request(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify(body),
    }).then(function (res) {
      return res.json().then(function (json) {
        if (!res.ok) throw new Error(json.description || json.message || "Request failed");
        return json;
      });
    });
  }

  window.ShopTheme = {
    config: config,
    routes: config.routes || {},
    formatMoney: formatMoney,
    fetchSections: fetchSections,
    replaceSection: replaceSection,
    lockScroll: lockScroll,
    unlockScroll: unlockScroll,
    request: request,
    mdQuery: window.matchMedia("(min-width: 768px)"),
  };
})();

/* ==== 10-header.js ==== */
/* Shop header (sections/shop-header.liquid): mobile navigation drawer and cart button, port of ShopHeader.tsx.
 * Everything is delegated on document and re-applied from a single state variable, because the cart script replaces
 * the inner HTML of #shop-header after every cart change (Section Rendering API) and the listeners must survive that. */
(function () {
  "use strict";

  var OPEN_LABEL = "Open navigation menu";
  var CLOSE_LABEL = "Close navigation menu";
  var navOpen = false;

  function header() {
    return document.getElementById("shop-header");
  }

  function find(selector) {
    var root = header();
    return root ? root.querySelector(selector) : null;
  }

  function closest(el, selector) {
    while (el && el.nodeType === 1) {
      if (el.matches(selector)) return el;
      el = el.parentNode;
    }
    return null;
  }

  function lock() {
    if (window.ShopTheme && window.ShopTheme.lockScroll) window.ShopTheme.lockScroll();
    else document.body.classList.add("shop-overflow-hidden");
  }

  function unlock() {
    if (window.ShopTheme && window.ShopTheme.unlockScroll) window.ShopTheme.unlockScroll();
    else document.body.classList.remove("shop-overflow-hidden");
  }

  /* Mirrors the React render: toggle classes, aria state, backdrop tabindex and the panel's inert attribute. */
  function apply() {
    var toggle = find("[data-shop-nav-toggle]");
    var backdrop = find("[data-shop-nav-backdrop]");
    var panel = find("[data-shop-nav-panel]");
    if (!toggle || !backdrop || !panel) return;

    toggle.classList.toggle("nav-drawer__toggle--close", navOpen);
    toggle.setAttribute("aria-expanded", navOpen ? "true" : "false");
    toggle.setAttribute("aria-label", navOpen ? CLOSE_LABEL : OPEN_LABEL);

    backdrop.classList.toggle("shop-header__backdrop--open", navOpen);
    backdrop.setAttribute("tabindex", navOpen ? "0" : "-1");

    panel.classList.toggle("shop-header__panel--open", navOpen);
    panel.setAttribute("aria-hidden", navOpen ? "false" : "true");
    if (navOpen) panel.removeAttribute("inert");
    else panel.setAttribute("inert", "");
  }

  function setNav(open) {
    open = !!open;
    if (open === navOpen) return;
    navOpen = open;
    if (navOpen) lock();
    else unlock();
    apply();
  }

  function closeNav(restoreFocus) {
    var wasOpen = navOpen;
    setNav(false);
    if (wasOpen && restoreFocus) {
      var toggle = find("[data-shop-nav-toggle]");
      if (toggle && typeof toggle.focus === "function") toggle.focus();
    }
  }

  /* Desktop "Cart (n)" and the mobile badge: show the count only when it is above zero, like the clone. */
  function renderCount(count) {
    var root = header();
    if (!root) return;
    var elements = root.querySelectorAll("[data-shop-cart-count]");
    var i;
    for (i = 0; i < elements.length; i += 1) {
      var value = elements[i].querySelector("[data-shop-cart-count-value]");
      if (value) value.textContent = String(count);
      if (count > 0) elements[i].removeAttribute("hidden");
      else elements[i].setAttribute("hidden", "");
    }
  }

  /* Same as handleCartClick in the React component; without the cart script the link simply navigates to /cart. */
  function openCart(event) {
    if (window.ShopCart && typeof window.ShopCart.open === "function") {
      event.preventDefault();
      window.ShopCart.open();
    }
  }

  document.addEventListener("click", function (event) {
    var target = event.target;
    if (!target || target.nodeType !== 1) return;

    var cartToggle = closest(target, "[data-shop-cart-toggle]");
    if (cartToggle && closest(cartToggle, "#shop-header")) {
      openCart(event);
      return;
    }

    var navToggle = closest(target, "[data-shop-nav-toggle]");
    if (navToggle && closest(navToggle, "#shop-header")) {
      setNav(!navOpen);
      return;
    }

    var backdrop = closest(target, "[data-shop-nav-backdrop]");
    if (backdrop && closest(backdrop, "#shop-header")) {
      closeNav(false);
      return;
    }

    /* Panel logo, close button and every drawer link close the drawer; links then navigate normally. */
    var closer = closest(target, "[data-shop-nav-close]");
    if (closer && closest(closer, "[data-shop-nav-panel]")) {
      closeNav(closer.tagName === "BUTTON");
    }
  });

  window.addEventListener("keydown", function (event) {
    if (!navOpen) return;
    if (event.key === "Escape" || event.key === "Esc") closeNav(true);
  });

  /* The drawer only exists below 768px: close it when the viewport grows past the breakpoint so the scroll lock lifts. */
  function onMediaChange(query) {
    if (query.matches) closeNav(false);
  }
  if (window.ShopTheme && window.ShopTheme.mdQuery) {
    if (window.ShopTheme.mdQuery.addEventListener) window.ShopTheme.mdQuery.addEventListener("change", onMediaChange);
    else if (window.ShopTheme.mdQuery.addListener) window.ShopTheme.mdQuery.addListener(onMediaChange);
  }

  /* After the cart script re-rendered the header, re-apply the drawer state and the count from the event detail. */
  document.addEventListener("shop:cart:updated", function (event) {
    apply();
    if (event.detail && typeof event.detail.itemCount === "number") renderCount(event.detail.itemCount);
  });

  /* Back-forward cache restores the page with a possibly stale locked body: reset to closed. */
  window.addEventListener("pageshow", function (event) {
    if (event.persisted) closeNav(false);
  });

  apply();
})();

/* ==== 20-carousel.js ==== */
/*
 * Shop carousel: vanilla port of src/components/sites/shop-adelaxo-com-4bfeda6a/shared/Carousel.tsx.
 * Replica of the Swiper slider used by the home featured collections (and the product gallery): a clipped
 * viewport, a translated flex track, 48px arrow boxes at top: 50% - 2px and 8px bullets 16px above the bottom.
 * Initialised on every [data-shop-carousel]. The section renders the markup (viewport, track with the slides,
 * prev/next nav, bullets for the desktop breakpoint); this script measures the viewport (ResizeObserver),
 * follows the 768px breakpoint, sets the slide widths and the track transform, handles arrows, bullets and
 * pointer drag (touch and pen, never mouse, like the store).
 *
 * Data attributes on the root:
 *   data-per-view-base / data-per-view-md   slides visible at once per breakpoint (required)
 *   data-gap-base / data-gap-md             gap between slides in px (required)
 *   data-per-group-base / data-per-group-md slides advanced per arrow click (default: per view)
 *   data-max-base / data-max-md             maximum slides shown per breakpoint; extra slides stay in the DOM
 *                                           hidden by the shop-carousel__hidden-base / -md classes the section sets
 *   data-show-bullets="false"               no bullets (the gallery renders its own thumbs)
 * Every root gets element.shopCarousel with goTo(index) and current, and dispatches shop:carousel:change
 * with { detail: { index } } so a controlling parent (gallery thumbs) can follow it.
 */
(function () {
  "use strict";

  var MD_QUERY = "(min-width: 768px)";
  var DRAG_THRESHOLD = 20;
  var mdMedia = window.matchMedia(MD_QUERY);

  function readInt(el, name, fallback) {
    var raw = el.getAttribute(name);
    if (raw === null || raw === "") return fallback;
    var value = parseInt(raw, 10);
    return isNaN(value) ? fallback : value;
  }

  function childSlides(track) {
    var out = [];
    for (var i = 0; i < track.children.length; i += 1) {
      if (track.children[i].tagName === "LI") out.push(track.children[i]);
    }
    return out;
  }

  function Carousel(root) {
    this.root = root;
    this.viewport = root.querySelector(".shop-carousel__viewport");
    this.track = root.querySelector(".shop-carousel__track");
    this.slides = childSlides(this.track);
    this.navPrev = root.querySelector(".shop-carousel__nav-prev");
    this.navNext = root.querySelector(".shop-carousel__nav-next");
    this.prevButton = root.querySelector("[data-shop-carousel-prev]");
    this.nextButton = root.querySelector("[data-shop-carousel-next]");
    this.pagination = root.querySelector("[data-shop-carousel-pagination]");

    this.perView = { base: readInt(root, "data-per-view-base", 1), md: readInt(root, "data-per-view-md", 1) };
    this.gap = { base: readInt(root, "data-gap-base", 0), md: readInt(root, "data-gap-md", 0) };
    var groupBase = readInt(root, "data-per-group-base", 0);
    var groupMd = readInt(root, "data-per-group-md", 0);
    this.perGroup = groupBase > 0 || groupMd > 0 ? { base: groupBase || this.perView.base, md: groupMd || this.perView.md } : null;
    var maxBase = readInt(root, "data-max-base", 0);
    var maxMd = readInt(root, "data-max-md", 0);
    this.maxSlides = maxBase > 0 || maxMd > 0 ? { base: maxBase || this.slides.length, md: maxMd || this.slides.length } : null;
    this.showBullets = root.getAttribute("data-show-bullets") !== "false";

    this.viewportWidth = null;
    this.isMd = mdMedia.matches;
    this.current = 0;
    this.drag = null;
    this.dragOffset = 0;
    this.dragging = false;

    this.bindEvents();
    this.observe();
    this.update();
  }

  Carousel.prototype.observe = function () {
    var self = this;
    if (typeof ResizeObserver !== "undefined") {
      this.observer = new ResizeObserver(function (entries) {
        var entry = entries[0];
        if (entry) {
          self.viewportWidth = entry.contentRect.width;
          self.update();
        }
      });
      this.observer.observe(this.viewport);
    } else {
      this.viewportWidth = this.viewport.clientWidth;
      window.addEventListener("resize", function () {
        self.viewportWidth = self.viewport.clientWidth;
        self.update();
      });
    }
    var onMedia = function () {
      self.isMd = mdMedia.matches;
      self.update();
    };
    if (mdMedia.addEventListener) mdMedia.addEventListener("change", onMedia);
    else mdMedia.addListener(onMedia);
  };

  /* Derived numbers for the current breakpoint (same formulas as Carousel.tsx). */
  Carousel.prototype.compute = function () {
    var isMd = this.isMd;
    var total = this.slides.length;
    var maxVisible = this.maxSlides ? (isMd ? this.maxSlides.md : this.maxSlides.base) : total;
    var slides = Math.min(total, Math.max(1, maxVisible));
    var view = Math.max(1, isMd ? this.perView.md : this.perView.base);
    var gapPx = isMd ? this.gap.md : this.gap.base;
    var group = Math.max(1, this.perGroup ? (isMd ? this.perGroup.md : this.perGroup.base) : view);
    var scrollable = slides > view;
    var groups = scrollable ? Math.ceil(slides / group) : 1;
    var measured = this.viewportWidth !== null;
    var slideWidth = measured ? (this.viewportWidth - gapPx * (view - 1)) / view : 0;
    return {
      slides: slides,
      view: view,
      gapPx: gapPx,
      group: group,
      scrollable: scrollable,
      groups: groups,
      measured: measured,
      slideWidth: slideWidth,
      step: slideWidth + gapPx,
    };
  };

  Carousel.prototype.offsetFor = function (state, g) {
    return Math.max(0, Math.min(g * state.group, state.slides - state.view)) * state.step;
  };

  Carousel.prototype.update = function () {
    var state = this.compute();
    this.state = state;
    var current = Math.min(Math.max(0, this.current), state.groups - 1);
    this.current = current;
    var offset = this.offsetFor(state, current);
    var i;

    if (state.measured) {
      this.track.style.transform = "translate3d(" + (-offset + this.dragOffset) + "px, 0, 0)";
      for (i = 0; i < this.slides.length; i += 1) {
        this.slides[i].style.width = state.slideWidth + "px";
        this.slides[i].style.marginRight = state.gapPx + "px";
      }
    }
    for (i = 0; i < this.slides.length; i += 1) {
      this.slides[i].setAttribute("aria-label", i + 1 + " / " + state.slides);
    }

    if (this.navPrev) this.navPrev.classList.toggle("shop-carousel__nav-hidden", !state.scrollable);
    if (this.navNext) this.navNext.classList.toggle("shop-carousel__nav-hidden", !state.scrollable);
    if (this.prevButton) this.prevButton.disabled = current <= 0;
    if (this.nextButton) this.nextButton.disabled = current >= state.groups - 1;

    this.renderBullets(state, current);
  };

  /* One bullet per group, rebuilt when the group count changes (8 slides: 2 groups on desktop, 4 on mobile). */
  Carousel.prototype.renderBullets = function (state, current) {
    var g;
    if (!this.showBullets || state.groups <= 1) {
      if (this.pagination && this.pagination.parentNode) this.pagination.parentNode.removeChild(this.pagination);
      this.pagination = null;
      return;
    }
    if (!this.pagination) {
      this.pagination = document.createElement("div");
      this.pagination.className = "swiper__pagination shop-carousel__pagination";
      this.pagination.setAttribute("data-shop-carousel-pagination", "");
      this.root.appendChild(this.pagination);
    }
    var bullets = this.pagination.querySelectorAll("[data-shop-carousel-bullet]");
    if (bullets.length !== state.groups) {
      this.pagination.innerHTML = "";
      for (g = 0; g < state.groups; g += 1) {
        var bullet = document.createElement("button");
        bullet.type = "button";
        bullet.className = "swiper-pagination-bullet shop-carousel__bullet";
        bullet.setAttribute("aria-label", "Go to slide " + (g + 1));
        bullet.setAttribute("data-shop-carousel-bullet", String(g));
        bullet.addEventListener("click", this.onBulletClick);
        this.pagination.appendChild(bullet);
      }
      bullets = this.pagination.querySelectorAll("[data-shop-carousel-bullet]");
    }
    for (g = 0; g < bullets.length; g += 1) {
      var active = g === current;
      bullets[g].classList.toggle("shop-carousel__bullet-active", active);
      if (active) bullets[g].setAttribute("aria-current", "true");
      else bullets[g].removeAttribute("aria-current");
    }
  };

  Carousel.prototype.goTo = function (next) {
    var state = this.state || this.compute();
    var clamped = Math.min(Math.max(0, next), state.groups - 1);
    if (clamped === this.current) return;
    this.current = clamped;
    this.update();
    var event;
    try {
      event = new CustomEvent("shop:carousel:change", { detail: { index: clamped } });
    } catch (e) {
      event = document.createEvent("CustomEvent");
      event.initCustomEvent("shop:carousel:change", false, false, { index: clamped });
    }
    this.root.dispatchEvent(event);
  };

  Carousel.prototype.bindEvents = function () {
    var self = this;
    this.onBulletClick = function (event) {
      self.goTo(readInt(event.currentTarget, "data-shop-carousel-bullet", 0));
    };
    if (this.prevButton) {
      this.prevButton.addEventListener("click", function () {
        self.goTo(self.current - 1);
      });
    }
    if (this.nextButton) {
      this.nextButton.addEventListener("click", function () {
        self.goTo(self.current + 1);
      });
    }
    if (this.pagination) {
      var bullets = this.pagination.querySelectorAll("[data-shop-carousel-bullet]");
      for (var g = 0; g < bullets.length; g += 1) bullets[g].addEventListener("click", this.onBulletClick);
    }

    this.track.addEventListener("pointerdown", function (event) {
      var state = self.state || self.compute();
      if (!state.scrollable || !state.measured) return;
      if (event.pointerType === "mouse") return;
      self.drag = { pointerId: event.pointerId, startX: event.clientX };
      if (self.track.setPointerCapture) self.track.setPointerCapture(event.pointerId);
      self.dragging = true;
      self.dragOffset = 0;
      self.track.classList.add("shop-carousel__dragging");
    });

    this.track.addEventListener("pointermove", function (event) {
      var drag = self.drag;
      if (!drag || drag.pointerId !== event.pointerId) return;
      self.dragOffset = event.clientX - drag.startX;
      var state = self.state || self.compute();
      self.track.style.transform = "translate3d(" + (-self.offsetFor(state, self.current) + self.dragOffset) + "px, 0, 0)";
    });

    this.track.addEventListener("pointerup", function (event) {
      self.endDrag(event);
    });

    this.track.addEventListener("pointercancel", function (event) {
      self.cancelDrag(event);
    });
  };

  Carousel.prototype.endDrag = function (event) {
    var drag = this.drag;
    if (!drag || drag.pointerId !== event.pointerId) return;
    this.drag = null;
    var dx = event.clientX - drag.startX;
    if (this.track.hasPointerCapture && this.track.hasPointerCapture(event.pointerId)) {
      this.track.releasePointerCapture(event.pointerId);
    }
    this.dragging = false;
    this.dragOffset = 0;
    this.track.classList.remove("shop-carousel__dragging");
    var state = this.state || this.compute();
    if (Math.abs(dx) <= DRAG_THRESHOLD || state.step <= 0) {
      this.update();
      return;
    }

    var offset = this.offsetFor(state, this.current);
    var target = offset - dx;
    var nearest = this.current;
    var best = Infinity;
    for (var g = 0; g < state.groups; g += 1) {
      var distance = Math.abs(this.offsetFor(state, g) - target);
      if (distance < best) {
        best = distance;
        nearest = g;
      }
    }
    if (nearest === this.current) nearest = dx < 0 ? this.current + 1 : this.current - 1;
    this.update();
    this.goTo(nearest);
  };

  Carousel.prototype.cancelDrag = function (event) {
    var drag = this.drag;
    if (!drag || drag.pointerId !== event.pointerId) return;
    this.drag = null;
    this.dragging = false;
    this.dragOffset = 0;
    this.track.classList.remove("shop-carousel__dragging");
    this.update();
  };

  function init(scope) {
    var roots = (scope || document).querySelectorAll("[data-shop-carousel]");
    for (var i = 0; i < roots.length; i += 1) {
      var root = roots[i];
      if (root.shopCarousel) continue;
      if (!root.querySelector(".shop-carousel__viewport") || !root.querySelector(".shop-carousel__track")) continue;
      root.shopCarousel = new Carousel(root);
    }
  }

  window.ShopCarousel = { init: init };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  /* Theme editor: sections re-render on every setting change. */
  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();

/* ==== 30-cart.js ==== */
/* Shop cart (window.ShopCart): port of shared/cart/CartProvider.tsx + CartDrawer.tsx + QuantitySpinner.tsx.
 * The localStorage cart of the Next clone is replaced by the Shopify cart: /cart/add.js and /cart/change.js through
 * ShopTheme.request, then the drawer, the header count and (on /cart) the cart page section are re-rendered through
 * the Section Rendering API. Every handler is delegated on document, so re-rendered markup needs no re-binding.
 * Every request is queued so fast clicks on a spinner never race each other. */
(function () {
  "use strict";
  var ShopTheme = window.ShopTheme;
  if (!ShopTheme) return;

  var routes = ShopTheme.routes || {};
  var DRAWER_SECTION = "shop-cart-drawer";
  var HEADER_SECTION = "shop-header";
  var DRAWER_ROOT = "#shop-cart-drawer";
  var PAGE_ROOT = "#shop-main-cart";
  var OPEN_CLASS = "shop-cart__drawer--open";

  var isOpen = false;
  var queue = Promise.resolve();

  function noop() {}

  function drawerRoot() {
    return document.querySelector(DRAWER_ROOT);
  }

  function drawerPanel() {
    var root = drawerRoot();
    return root ? root.querySelector("[data-shop-cart-drawer]") : null;
  }

  function pageRoot() {
    return document.querySelector(PAGE_ROOT);
  }

  /* Section id of the cart page section (JSON template sections are addressed by section.id, not by file name). */
  function pageSectionId() {
    var page = pageRoot();
    return page ? page.getAttribute("data-shop-section-id") : null;
  }

  function itemCount() {
    var panel = drawerPanel();
    return panel ? parseInt(panel.getAttribute("data-shop-cart-item-count") || "0", 10) || 0 : 0;
  }

  /* ------------------------------------------------------------------ open state (CartDrawer.tsx) */

  function applyState() {
    var root = drawerRoot();
    var panel = drawerPanel();
    if (!root || !panel) return;
    root.classList.toggle("is-open", isOpen);
    panel.classList.toggle(OPEN_CLASS, isOpen);
    panel.setAttribute("aria-hidden", isOpen ? "false" : "true");
    if (isOpen) panel.removeAttribute("inert");
    else panel.setAttribute("inert", "");
  }

  function open() {
    if (isOpen || !drawerPanel()) return;
    isOpen = true;
    ShopTheme.lockScroll();
    applyState();
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    ShopTheme.unlockScroll();
    applyState();
  }

  /* ------------------------------------------------------------------ rendering */

  /* Copies the header's [data-shop-cart-count] into every count element on the page (desktop text and mobile badge). */
  function renderCounts(headerHtml) {
    if (!headerHtml) return;
    var doc = new DOMParser().parseFromString(headerHtml, "text/html");
    var next = doc.querySelectorAll("[data-shop-cart-count]");
    if (!next.length) return;
    var current = document.querySelectorAll("[data-shop-cart-count]");
    for (var i = 0; i < current.length; i += 1) {
      var source = next[i] || next[0];
      current[i].innerHTML = source.innerHTML;
      if (source.hasAttribute("hidden")) current[i].setAttribute("hidden", "");
      else current[i].removeAttribute("hidden");
    }
  }

  function render(sections) {
    if (sections[DRAWER_SECTION]) ShopTheme.replaceSection(sections[DRAWER_SECTION], DRAWER_ROOT);
    renderCounts(sections[HEADER_SECTION]);
    var pageId = pageSectionId();
    if (pageId && sections[pageId]) ShopTheme.replaceSection(sections[pageId], PAGE_ROOT);
    applyState();
    var count = itemCount();
    document.dispatchEvent(new CustomEvent("shop:cart:updated", { detail: { itemCount: count } }));
    return count;
  }

  /* Re-renders the drawer, the header count and the cart page from the current Shopify cart. The sections are
   * always requested from /cart: the drawer and header are static sections available on every page and the copied
   * count does not depend on the page, while the cart page section only exists on /cart. */
  function refresh() {
    var names = [DRAWER_SECTION, HEADER_SECTION];
    var pageId = pageSectionId();
    if (pageId) names.push(pageId);
    return ShopTheme.fetchSections(names, routes.cart || "/cart").then(render);
  }

  /* ------------------------------------------------------------------ mutations (CartProvider.tsx) */

  function enqueue(task) {
    var run = queue.then(task, task);
    queue = run.then(noop, noop);
    return run;
  }

  function mutate(url, body, openAfter) {
    return enqueue(function () {
      return ShopTheme.request(url, body)
        .then(refresh)
        .then(function (count) {
          if (openAfter) open();
          return count;
        });
    });
  }

  /* addLine: adds quantity of the variant and opens the drawer. */
  function add(variantId, quantity, properties) {
    var qty = parseInt(quantity, 10);
    if (!(qty > 0)) qty = 1;
    var item = { id: parseInt(variantId, 10) || variantId, quantity: qty };
    /* The store's product form posts properties[_shipdate] for pre-orders; the cart line renders "Ships on:" from it. */
    if (properties && Object.keys(properties).length) item.properties = properties;
    return mutate(routes.cartAdd || "/cart/add.js", { items: [item] }, true);
  }

  /* setQuantity / removeLine: quantity 0 removes the line. */
  function change(key, quantity) {
    var qty = parseInt(quantity, 10);
    if (!(qty >= 0)) qty = 0;
    return mutate(routes.cartChange || "/cart/change.js", { id: key, quantity: qty }, false);
  }

  function fail(error) {
    if (window.console) console.error(error);
    /* The cart request was rejected (sold out, limit reached): put the rendered state back. */
    refresh().catch(noop);
  }

  /* ------------------------------------------------------------------ quantity spinner (QuantitySpinner.tsx) */

  function spinnerMin(spinner) {
    return (spinner && parseInt(spinner.getAttribute("data-shop-quantity-min"), 10)) || 1;
  }

  /* Mirrors commit(): finite numbers are rounded and clamped to min, anything else becomes min. */
  function clamp(value, min) {
    var number = Number(value);
    return Math.max(min, isFinite(number) ? Math.round(number) : min);
  }

  function onStepClick(step) {
    var spinner = step.closest("[data-shop-quantity]");
    var input = spinner ? spinner.querySelector("[data-shop-quantity-input]") : null;
    if (!input) return;
    var min = spinnerMin(spinner);
    var current = parseInt(input.value, 10);
    if (isNaN(current)) current = min;
    var next = clamp(current + (parseInt(step.getAttribute("data-shop-quantity-step"), 10) || 0), min);
    if (next === current && input.value === String(current)) return;
    input.value = String(next);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function onQuantityChange(input) {
    var spinner = input.closest("[data-shop-quantity]");
    var min = spinnerMin(spinner);
    var raw = input.value.trim();
    var value = raw === "" ? min : clamp(parseInt(raw, 10), min);
    if (input.value !== String(value)) input.value = String(value);
    var line = input.closest("[data-shop-line-key]");
    if (!line) return;
    if (String(value) === line.getAttribute("data-shop-line-quantity")) return;
    change(line.getAttribute("data-shop-line-key"), value).catch(fail);
  }

  /* ------------------------------------------------------------------ delegated handlers */

  function onClick(event) {
    var target = event.target;
    if (!(target instanceof Element)) return;

    var step = target.closest("[data-shop-quantity-step]");
    if (step) {
      onStepClick(step);
      return;
    }

    var remove = target.closest("[data-shop-cart-remove]");
    if (remove) {
      remove.disabled = true;
      change(remove.getAttribute("data-shop-cart-remove"), 0).catch(fail);
      return;
    }

    var addButton = target.closest("[data-shop-cart-add]");
    if (addButton) {
      addButton.disabled = true;
      var restore = function () {
        addButton.disabled = false;
      };
      var shipDate = addButton.getAttribute("data-shop-cart-add-ships-on");
      add(addButton.getAttribute("data-shop-cart-add"), addButton.getAttribute("data-shop-cart-add-quantity") || 1, shipDate ? { _shipdate: shipDate } : null).then(restore, function (error) {
        restore();
        fail(error);
      });
      return;
    }

    if (target.closest("[data-shop-cart-close]") || target.closest("[data-shop-cart-overlay]")) {
      close();
      return;
    }

    var opener = target.closest("[data-shop-cart-open]");
    if (opener && drawerPanel()) {
      event.preventDefault();
      open();
    }
  }

  function onChange(event) {
    var input = event.target;
    if (!(input instanceof HTMLInputElement) || !input.hasAttribute("data-shop-quantity-input")) return;
    onQuantityChange(input);
  }

  function onKeyDown(event) {
    if (event.key === "Escape" && isOpen) close();
  }

  document.addEventListener("click", onClick);
  document.addEventListener("change", onChange);
  window.addEventListener("keydown", onKeyDown);

  window.ShopCart = {
    add: add,
    change: change,
    open: open,
    close: close,
    refresh: refresh,
    isOpen: function () {
      return isOpen;
    },
    itemCount: itemCount,
  };

  applyState();
})();

/* ==== 40-product.js ==== */
/*
 * Shop product page (section shop-main-product): port of ProductTemplate, ProductGallery, ProductInfo and
 * ZoomDialog. Variant selection (price, availability, button state, ?variant= in the URL, gallery image of the
 * variant), gallery navigation (arrows, bullets, thumbnails, swipe), the zoom dialog and add to cart through
 * window.ShopCart.add. Reads the product JSON from [data-shop-product-json].
 */
(function () {
  "use strict";

  var ZOOM_MIN_WIDTH = 768;
  var DRAG_THRESHOLD = 20;
  var SLIDE_GAP = 16;

  function toArray(list) {
    return Array.prototype.slice.call(list || []);
  }

  function readJson(root) {
    var node = root.querySelector("[data-shop-product-json]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (error) {
      return null;
    }
  }

  /* Option values of a variant in option order (Liquid JSON ships `options`; option1..3 is the fallback). */
  function variantOptions(variant) {
    if (variant.options && variant.options.length) return variant.options;
    var values = [];
    ["option1", "option2", "option3"].forEach(function (key) {
      if (variant[key] !== null && variant[key] !== undefined) values.push(variant[key]);
    });
    return values;
  }

  /* ---------------------------------------------------------------------------
   * Gallery: one per view carousel driven by arrows, bullets, thumbs, swipe and the selected variant.
   * ------------------------------------------------------------------------- */
  function Gallery(root) {
    this.root = root;
    this.viewport = root.querySelector("[data-shop-product-viewport]");
    this.track = root.querySelector("[data-shop-product-track]");
    this.slides = toArray(root.querySelectorAll("[data-shop-product-slide]"));
    this.prev = root.querySelector('[data-shop-product-nav="prev"]');
    this.next = root.querySelector('[data-shop-product-nav="next"]');
    this.bullets = toArray(root.querySelectorAll("[data-shop-product-bullet]"));
    this.thumbs = toArray(root.querySelectorAll("[data-shop-product-thumb]"));
    this.count = this.slides.length;
    this.index = 0;
    this.slideWidth = 0;
    this.dragOffset = 0;
    this.drag = null;
    this.bind();
    this.measure();
  }

  Gallery.prototype.bind = function () {
    var self = this;
    if (this.prev) {
      this.prev.addEventListener("click", function () {
        self.goTo(self.index - 1);
      });
    }
    if (this.next) {
      this.next.addEventListener("click", function () {
        self.goTo(self.index + 1);
      });
    }
    this.bullets.forEach(function (bullet) {
      bullet.addEventListener("click", function () {
        self.goTo(parseInt(bullet.getAttribute("data-shop-product-bullet"), 10));
      });
    });
    this.thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        self.goTo(parseInt(thumb.getAttribute("data-shop-product-thumb"), 10));
      });
    });

    if (this.track && window.PointerEvent) {
      this.track.addEventListener("pointerdown", function (event) {
        self.onPointerDown(event);
      });
      this.track.addEventListener("pointermove", function (event) {
        self.onPointerMove(event);
      });
      this.track.addEventListener("pointerup", function (event) {
        self.endDrag(event);
      });
      this.track.addEventListener("pointercancel", function (event) {
        self.cancelDrag(event);
      });
    }

    if (this.viewport) {
      if (window.ResizeObserver) {
        new ResizeObserver(function () {
          self.measure();
        }).observe(this.viewport);
      } else {
        window.addEventListener("resize", function () {
          self.measure();
        });
      }
    }
  };

  Gallery.prototype.measure = function () {
    if (!this.viewport) return;
    this.slideWidth = this.viewport.clientWidth;
    this.render();
  };

  Gallery.prototype.step = function () {
    return this.slideWidth + SLIDE_GAP;
  };

  Gallery.prototype.offsetFor = function (index) {
    return Math.max(0, Math.min(index, this.count - 1)) * this.step();
  };

  Gallery.prototype.goTo = function (next) {
    var clamped = Math.min(Math.max(0, next), Math.max(0, this.count - 1));
    if (clamped === this.index) return;
    this.index = clamped;
    this.render();
  };

  Gallery.prototype.render = function () {
    var self = this;
    var scrollable = this.count > 1;
    if (this.track) {
      var offset = this.slideWidth ? this.offsetFor(this.index) : 0;
      this.track.style.transform = "translate3d(" + (-offset + this.dragOffset) + "px, 0, 0)";
    }
    if (this.prev) this.prev.disabled = !scrollable || this.index <= 0;
    if (this.next) this.next.disabled = !scrollable || this.index >= this.count - 1;
    this.bullets.forEach(function (bullet, i) {
      var active = i === self.index;
      bullet.classList.toggle("shop-product__bullet--active", active);
      if (active) bullet.setAttribute("aria-current", "true");
      else bullet.removeAttribute("aria-current");
    });
    this.thumbs.forEach(function (thumb, i) {
      var active = i === self.index;
      var inner = thumb.querySelector(".shop-product__thumb-inner");
      if (active) thumb.setAttribute("aria-current", "true");
      else thumb.removeAttribute("aria-current");
      if (inner) inner.classList.toggle("shop-product__thumb-inner--active", active);
    });
  };

  Gallery.prototype.onPointerDown = function (event) {
    if (this.count < 2 || !this.slideWidth) return;
    if (event.pointerType === "mouse") return;
    this.drag = { pointerId: event.pointerId, startX: event.clientX };
    if (this.track.setPointerCapture) this.track.setPointerCapture(event.pointerId);
    this.track.classList.add("shop-product__track--dragging");
    this.dragOffset = 0;
  };

  Gallery.prototype.onPointerMove = function (event) {
    if (!this.drag || this.drag.pointerId !== event.pointerId) return;
    this.dragOffset = event.clientX - this.drag.startX;
    this.render();
  };

  Gallery.prototype.endDrag = function (event) {
    if (!this.drag || this.drag.pointerId !== event.pointerId) return;
    var dx = event.clientX - this.drag.startX;
    this.drag = null;
    if (this.track.hasPointerCapture && this.track.hasPointerCapture(event.pointerId)) {
      this.track.releasePointerCapture(event.pointerId);
    }
    this.track.classList.remove("shop-product__track--dragging");
    this.dragOffset = 0;
    if (Math.abs(dx) <= DRAG_THRESHOLD || this.step() <= 0) {
      this.render();
      return;
    }
    var target = this.offsetFor(this.index) - dx;
    var nearest = this.index;
    var best = Infinity;
    for (var i = 0; i < this.count; i += 1) {
      var distance = Math.abs(this.offsetFor(i) - target);
      if (distance < best) {
        best = distance;
        nearest = i;
      }
    }
    if (nearest === this.index) nearest = dx < 0 ? this.index + 1 : this.index - 1;
    this.render();
    this.goTo(nearest);
  };

  Gallery.prototype.cancelDrag = function (event) {
    if (!this.drag || this.drag.pointerId !== event.pointerId) return;
    this.drag = null;
    this.track.classList.remove("shop-product__track--dragging");
    this.dragOffset = 0;
    this.render();
  };

  /* ---------------------------------------------------------------------------
   * Zoom dialog: native <dialog> with showModal() from 768px; Escape and the close button close it.
   * ------------------------------------------------------------------------- */
  function ZoomDialog(root) {
    var self = this;
    this.dialog = root.querySelector("[data-shop-product-dialog]");
    this.locked = false;
    if (!this.dialog) return;

    toArray(root.querySelectorAll("[data-shop-product-zoom]")).forEach(function (button) {
      button.addEventListener("click", function () {
        self.open();
      });
    });
    toArray(this.dialog.querySelectorAll("[data-shop-product-dialog-close]")).forEach(function (button) {
      button.addEventListener("click", function () {
        self.close();
      });
    });
    this.dialog.addEventListener("close", function () {
      self.unlock();
    });
  }

  ZoomDialog.prototype.open = function () {
    if (!this.dialog || typeof this.dialog.showModal !== "function") return;
    if (window.innerWidth < ZOOM_MIN_WIDTH) return;
    if (this.dialog.open) return;
    this.dialog.showModal();
    if (window.ShopTheme && ShopTheme.lockScroll) {
      ShopTheme.lockScroll();
      this.locked = true;
    }
  };

  ZoomDialog.prototype.close = function () {
    if (this.dialog && this.dialog.open) this.dialog.close();
  };

  ZoomDialog.prototype.unlock = function () {
    if (this.locked && window.ShopTheme && ShopTheme.unlockScroll) ShopTheme.unlockScroll();
    this.locked = false;
  };

  /* ---------------------------------------------------------------------------
   * Product: variant selection and add to cart.
   * ------------------------------------------------------------------------- */
  function Product(root) {
    var data = readJson(root);
    if (!data || !data.variants || !data.variants.length) return;
    this.root = root;
    this.data = data;
    this.title = data.title || "";
    this.variants = data.variants;
    this.imageVariantIds = data.imageVariantIds || [];
    this.gallery = new Gallery(root);
    this.zoom = new ZoomDialog(root);

    this.price = root.querySelector("[data-shop-product-price]");
    this.idInput = root.querySelector("[data-shop-product-id]");
    this.form = root.querySelector("[data-shop-product-form]");
    this.submit = root.querySelector("[data-shop-product-submit]");
    this.submitLabel = root.querySelector("[data-shop-product-submit-label]");
    this.quantityWrapper = root.querySelector("[data-shop-product-quantity]");
    this.quantityInput = this.quantityWrapper ? this.quantityWrapper.querySelector("[data-shop-quantity-input]") : null;
    this.radios = toArray(root.querySelectorAll("[data-shop-product-option]"));
    this.quantity = 1;

    var initial = this.findVariantById(data.selectedVariantId) || this.variants[0];
    this.selected = initial;
    this.applyVariant(initial, true);
    this.bind();
  }

  Product.prototype.findVariantById = function (id) {
    var wanted = Number(id);
    for (var i = 0; i < this.variants.length; i += 1) {
      if (Number(this.variants[i].id) === wanted) return this.variants[i];
    }
    return null;
  };

  Product.prototype.bind = function () {
    var self = this;
    this.radios.forEach(function (radio) {
      radio.addEventListener("change", function () {
        self.selectOption(parseInt(radio.getAttribute("data-shop-product-option"), 10), radio.value);
      });
    });
    if (this.quantityInput) {
      this.quantityInput.addEventListener("change", function () {
        self.quantity = self.readQuantity();
      });
    }
    if (this.form) {
      this.form.addEventListener("submit", function (event) {
        event.preventDefault();
        self.addToCart();
      });
    }
    var soldOutForm = this.root.querySelector("[data-shop-product-sold-out-form]");
    if (soldOutForm) {
      soldOutForm.addEventListener("submit", function (event) {
        event.preventDefault();
      });
    }
  };

  Product.prototype.readQuantity = function () {
    if (!this.quantityInput) return 1;
    var parsed = parseInt(this.quantityInput.value, 10);
    return isNaN(parsed) ? 1 : Math.max(1, parsed);
  };

  /* Picking a pill selects the variant whose options equal the chosen values. */
  Product.prototype.selectOption = function (optionIndex, value) {
    var current = variantOptions(this.selected);
    var wanted = current.map(function (option, i) {
      return i === optionIndex ? value : option;
    });
    var match = null;
    for (var i = 0; i < this.variants.length; i += 1) {
      var options = variantOptions(this.variants[i]);
      var equal = options.length === wanted.length;
      for (var j = 0; equal && j < options.length; j += 1) {
        if (String(options[j]) !== String(wanted[j])) equal = false;
      }
      if (equal) {
        match = this.variants[i];
        break;
      }
    }
    if (match) this.selectVariant(match);
    else this.syncRadios();
  };

  Product.prototype.selectVariant = function (variant) {
    this.selected = variant;
    this.applyVariant(variant, false);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, "", "?variant=" + variant.id);
    }
  };

  /* Updates price, hidden id, button state, spinner labels, radios and the gallery image of the variant. */
  Product.prototype.applyVariant = function (variant, initial) {
    var available = variant.available !== false;
    if (this.idInput) this.idInput.value = variant.id;
    if (this.price && window.ShopTheme && ShopTheme.formatMoney) {
      this.price.textContent = ShopTheme.formatMoney(variant.price);
    }
    if (this.submit) this.submit.disabled = !available;
    /* The label of an available variant is whatever the section rendered, a presale on this store, so it is
     * read off the button rather than written back as "Add to cart" on every variant change. */
    if (this.submitLabel) {
      if (!this.availableLabel) this.availableLabel = this.submitLabel.textContent.trim() || "Add to cart";
      this.submitLabel.textContent = available ? this.availableLabel : "Sold out";
    }
    this.updateSpinnerLabels(variant);
    this.syncRadios();

    var imageIndex = -1;
    for (var i = 0; i < this.imageVariantIds.length; i += 1) {
      var ids = this.imageVariantIds[i] || [];
      for (var j = 0; j < ids.length; j += 1) {
        if (Number(ids[j]) === Number(variant.id)) imageIndex = i;
      }
      if (imageIndex >= 0) break;
    }
    if (imageIndex >= 0 && (!initial || imageIndex !== this.gallery.index)) this.gallery.goTo(imageIndex);
  };

  Product.prototype.updateSpinnerLabels = function (variant) {
    if (!this.quantityWrapper) return;
    var label = this.title + " - " + variant.title;
    toArray(this.quantityWrapper.querySelectorAll("[data-shop-quantity-step]")).forEach(function (button) {
      var step = button.getAttribute("data-shop-quantity-step");
      button.setAttribute("aria-label", (step === "-1" ? "Decrease" : "Increase") + " quantity for " + label);
    });
  };

  Product.prototype.syncRadios = function () {
    var options = variantOptions(this.selected);
    this.radios.forEach(function (radio) {
      var index = parseInt(radio.getAttribute("data-shop-product-option"), 10);
      radio.checked = String(options[index]) === String(radio.value);
    });
  };

  Product.prototype.addToCart = function () {
    var self = this;
    var variant = this.selected;
    if (!variant || variant.available === false) return;
    var quantity = this.readQuantity();
    this.quantity = quantity;

    function done() {
      if (self.submit) {
        self.submit.disabled = false;
        self.submit.removeAttribute("aria-busy");
      }
    }

    if (this.submit) {
      this.submit.disabled = true;
      this.submit.setAttribute("aria-busy", "true");
    }

    var result = null;
    if (window.ShopCart && typeof ShopCart.add === "function") {
      var shipDate = this.form.getAttribute("data-shop-ships-on");
      result = ShopCart.add(variant.id, quantity, shipDate ? { _shipdate: shipDate } : null);
    } else if (window.ShopTheme && ShopTheme.request && ShopTheme.routes && ShopTheme.routes.cartAdd) {
      /* Cart script missing (should not happen on shop pages): add through the AJAX API and go to the cart page. */
      result = ShopTheme.request(ShopTheme.routes.cartAdd, { items: [{ id: variant.id, quantity: quantity }] }).then(function () {
        window.location.href = ShopTheme.routes.cart || "/cart";
      });
    }
    if (result && typeof result.then === "function") {
      result.then(done, done);
    } else {
      done();
    }
  };

  function init() {
    toArray(document.querySelectorAll("[data-shop-product]")).forEach(function (root) {
      if (root.shopProduct) return;
      root.shopProduct = new Product(root);
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* ==== 60-policy.js ==== */
/* Policy pages: Shopify prints the policy's own title in the h1; the store shows different wording per handle
   (terms-of-service -> "Terms and conditions of Sale", legal-notice -> "Do not sell my information",
   privacy-policy -> "Privacy policy"). Rewrites the h1 and document.title on the policy template. */
(function () {
  "use strict";

  var TITLES = {
    "terms-of-service": "Terms and conditions of Sale",
    "legal-notice": "Do not sell my information",
    "privacy-policy": "Privacy policy",
  };
  var TITLE_SUFFIX = " - ADÉLA Official Store";

  function isPolicyPage() {
    var body = document.body;
    if (body && (" " + body.className + " ").indexOf(" template-policy ") !== -1) return true;
    return !!document.querySelector(".shopify-policy__container");
  }

  function run() {
    if (!isPolicyPage()) return;
    var match = window.location.pathname.match(/\/policies\/([^\/?#]+)/);
    if (!match) return;
    var title = TITLES[match[1]];
    if (!title) return;
    var heading = document.querySelector(".shopify-policy__title h1");
    if (heading) heading.textContent = title;
    document.title = title + TITLE_SUFFIX;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
})();
